import { Icon } from './Icon'
import type { IconProps } from './Icon'
export const RefreshIcon = (p: IconProps) => <Icon {...p}><path d="M3 12a9 9 0 0 1 9-9 9 9 0 0 1 6.7 3L21 8" /><path d="M21 3v5h-5" /><path d="M21 12a9 9 0 0 1-9 9 9 9 0 0 1-6.7-3L3 16" /><path d="M3 21v-5h5" /></Icon>
